@if (!dataLoaded()) {
  <ngx-skeleton-loader
    count="1"
    appearance="circle"
    [theme]="{
      'border-radius': '5px',
      height: '4.5rem',
      width: '15rem',
    }"
  />

  <ngx-skeleton-loader
    count="2"
    appearance="circle"
    [theme]="{
      'border-radius': '5px',
      height: '2rem',
      width: '7rem',
    }"
  />
}

<div class="d-flex justify-content-start flex-wrap">
  @if (dataLoaded()) {
    <div class="mb-1 me-2">
      <div class="mb-2 d-flex justify-content-bewteen">
        <a class="h1 sneaky-link" href="/cert/educators/{{ personId }}" (click)="navigateToEducatorManagement($event)">
          {{ educatorDetail.lastName }}, {{ educatorDetail.firstName }} {{ educatorDetail.middleInitial }}
        </a>
        <span class="ps-2 mt-1">
          <cert-pd-requirement-state [pdRequirementState]="educatorDetail.overallPdState" />
          <cert-special-program-badge [specialPrograms]="educatorDetail.specialPrograms" />
          @for (alert of educatorDetail.alerts; track $index) {
            <span class="badge badge-danger m-2 alert-badge"
              >{{ alert.display }}
              @if (alert.canManuallyRemoveAlert && canDeleteAlerts) {
                <span
                  class="bi-x-circle-fill align-middle clickable"
                  (click)="openDeleteAlertModal(alert.personAlertId)"
                ></span>
              }
            </span>
          }
          @if (canAddAlerts) {
            <span class="badge badge-light m-1 opacity-50 badge-skeleton" (click)="openAddAlertModal()"
              >Add Alert <span class="bi-plus-circle-fill align-middle"></span></span
            >&nbsp;
          }
        </span>
      </div>
      <div class="d-flex gap-3 fs-5 align-items-center">
        @if (educatorDetail.ein ?? null) {
          <div>
            <span class="fw-bold me-1">EIN:</span>
            <span>{{ educatorDetail.ein }}</span>
            <cert-linked-educator-icon [linkedEducatorContext]="linkedEducatorContext"></cert-linked-educator-icon>
          </div>
        }
        @if (educatorDetail.educatorStakeholderId ?? null) {
          <div>
            <span class="fw-bold me-1">Stakeholder Id:</span>
            <span>{{ educatorDetail.educatorStakeholderId | guidFormat }}</span>
          </div>
        }
        <div>
          <span>
            @switch (educatorDetail.validityStatus) {
              @case (fingerprintCardValidityStatus.NotOnFile) {
                <span class="fw-bold me-1">IVP Fingerprint:</span>Not On File<i
                  class="bi bi-stop-circle ps-1 text-danger"
                ></i>
              }
              @case (fingerprintCardValidityStatus.Valid) {
                <span class="fw-bold me-1">IVP Fingerprint:</span>Valid
                <i class="bi bi-check-circle ps-1 text-success"></i>
              }
              @case (fingerprintCardValidityStatus.Pending) {
                <span class="fw-bold me-1">IVP Fingerprint:</span>Pending<i
                  class="bi bi-exclamation-circle ps-1 text-warning"
                ></i>
              }
              @case (fingerprintCardValidityStatus.NotValid) {
                <span class="fw-bold me-1">IVP Fingerprint:</span>Not Valid<i
                  class="bi bi-stop-circle ps-1 text-danger"
                ></i>
              }
              @case (fingerprintCardValidityStatus.Expired) {
                <span class="fw-bold me-1">IVP Fingerprint:</span>
                Expired<i class="bi bi-x-circle ps-1 text-danger"></i>
              }
              @default {
                <span class="fw-bold me-1">IVP Fingerprint:</span>
                Not On File<i class="bi bi-stop-circle ps-1 text-danger"></i>
              }
            }
          </span>
          @if (educatorDetail.potentialMismatchedFingerprintAssociation) {
            <cert-mismatched-fingerprint-association-popover
              [potentialMismatchedFingerprintAssociation]="educatorDetail.potentialMismatchedFingerprintAssociation"
            />
          }
          @if (educatorDetail.hasUnacknowledgedFingerprintReceived) {
            <span
              class="badge badge-warning ms-2 my-auto"
              [certTooltip]="'New fingerprint has not been acknowledged by the assigned user'"
              >New</span
            >
          }
        </div>
        <span class="me-3">
          <span class="fw-bold me-1">Current Employment:</span>
          <span>{{ educatorCurrentEmployment }}</span>
        </span>
        @if (educatorDetail.mergedEins.length > 0) {
          <div>
            <span class="fw-bold me-1">Merged EIN(s):</span>
            @for (ein of educatorDetail.mergedEins; track ein; let last = $last) {
              <span>{{ ein }}</span>
              @if (!last) {
                <span>, </span>
              }
            }
          </div>
        }
        <span class="me-3">
          <span class="fw-bold me-1">ADE Connect Account:</span>
          <span>{{ educatorDetail.adeConnectAccount }}</span>
        </span>
      </div>
    </div>
  }
  <div class="ms-auto">
    <div class="float-end">
      @if (
        screenShareEnabled &&
        canInitiateEducatorScreenShare &&
        screenShareAvailabilityState &&
        screenShareAvailabilityState.hasEducatorUserAccount
      ) {
        @if (screenShareAvailabilityState.isConnectedToScreenShareHub) {
          <button
            class="btn btn-outline-primary ms-auto m-2"
            (click)="requestScreenShare()"
            certTooltip="Send educator a screen share request."
          >
            Request Screen Share
          </button>
        } @else {
          <button
            class="btn btn-outline-primary ms-auto m-2"
            (click)="refreshScreenShareAvailability()"
            certTooltip="Educator is not currently online and cannot receive screen share requests."
          >
            Refresh Screen Share Availability
          </button>
        }
      }
      <button
        requiresPolicy="canViewNotes"
        class="btn btn-outline-primary ms-auto m-2"
        (click)="openEducatorNotesCanvas()"
      >
        Notes<i class="journal-icon ps-1"></i>
      </button>
    </div>
  </div>
</div>
